import Button from '@modules/common/components/button'
import React from 'react'

interface QuantitySelectorProps {
  quantity: number
  maxQuantityMet: boolean
  setQuantity: (quantity: number) => void
  disabled?: boolean
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  maxQuantityMet,
  setQuantity,
  disabled = false,
}) => {
  const isMinQuantity = quantity === 1

  const handleDecrease = () => {
    if (!isMinQuantity) {
      setQuantity(quantity - 1)
    }
  }

  const handleIncrease = () => {
    if (!maxQuantityMet) {
      setQuantity(quantity + 1)
    }
  }

  return (
    <div className="flex items-center justify-left text-xl gap-2 xs:pt-4 sm:pt-0">
      <Button
        className="w-6 border border-black"
        disabled={isMinQuantity || disabled}
        onClick={handleDecrease}
      >
        -
      </Button>
      <input
        className="xs:text-sm text-center text-xl h-[50px] w-16 border border-gray-300 px-2 "
        value={quantity > 0 ? quantity : ''}
        onChange={(e) => {
          const inputVal = e.target.value
          const parsedVal = parseInt(inputVal)
          // Update the quantity state with the parsed positive integer value
          setQuantity(parsedVal)
        }}
        disabled={disabled || (maxQuantityMet && quantity === 1)}
      />

      <Button
        className="w-6 border border-black"
        disabled={maxQuantityMet || disabled}
        onClick={handleIncrease}
      >
        +
      </Button>
    </div>
  )
}

export default QuantitySelector
